module.exports = __webpack_public_path__ + "frontend/images/white/carousel/account@2.png?12e520eea94536198e38953ba2a204ab";